import * as variables from './variables';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu } from './component/MainMenu';
new MainMenu({
	menuID: 'menu',
	toggles: '.menuToggle',
	focusLock: {
		dialog: '.menu',
		return: '.menuToggle--open',
		toggle: '.menuToggle--close'
	},
	styleClass: {
		menuOpen: 'hasMenuOpen'
	}
});

// Events
// On tab panels set ARIA attributes that cannot set on group block
const eventsCalendarListViewPanel = document.querySelector(".panel--list-view"); // Modify group block wrapping event "list view" results
if (eventsCalendarListViewPanel) {
	eventsCalendarListViewPanel.setAttribute("role", "tabpanel");
	eventsCalendarListViewPanel.setAttribute("aria-labelledby", "list-view");
}
import Tabs from './component/tabs';
new Tabs();


// Accessibility: places role="alert" on "Maximum number of files reached" message on https://www.ricecreek.org/grants/water-quality-grant-inspection-program/
// https://hub.accessible360.com/projects/9436/issues/55/
document.addEventListener('DOMContentLoaded', function () {
	// Watch the entire document for any validation messages being added
	const observer = new MutationObserver(function (mutationsList) {
		mutationsList.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				// Check if the added node is an element
				if (node instanceof Element) {
					// If the node itself is the message, or contains the message
					const validationMsgs = node.classList.contains('gfield_validation_message')
						? [node]
						: Array.from(node.querySelectorAll('.gfield_validation_message'));

					validationMsgs.forEach(msg => {
						if (!msg.hasAttribute('role')) {
							msg.setAttribute('role', 'alert');
						}
					});
				}
			});
		});
	});

	// Observe the body to catch dynamically injected forms and messages
	observer.observe(document.body, { childList: true, subtree: true });
});

// Carousel accessibility: wrap the carousel in either a <section> or a <div role="region"> tag. Be sure to add an aria-label containing the word "carousel" to this wrapper element. When there are multiple carousels on a page, ensure that each has a unique aria-label.
// https://hub.accessible360.com/projects/9436/issues/71/
document.addEventListener('DOMContentLoaded', function() {
	const carousels = document.querySelectorAll('.swiper-container');

	carousels.forEach((carousel, index) => {
		const count = index + 1;
		let label = '';

		if (document.body.classList.contains('single-project')) {
			label = `Project carousel${count > 1 ? ' ' + count : ''}`;
		} else if (document.body.classList.contains('page-id-370')) {
			label = `Previous projects carousel${count > 1 ? ' ' + count : ''}`;
		} else {
			label = `Carousel${count > 1 ? ' ' + count : ''}`;
		}

		carousel.setAttribute('role', 'region');
		carousel.setAttribute('aria-label', label);

		// Unique ID needed to satisfy many accessibility audits (specifically under WCAG 4.1.1: Parsing)
		if (!carousel.id) {
			carousel.id = `automated-carousel-${count}`;
		}
	});
});

// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance([
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .pageFooter__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .pageFooter__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// ]);
// ---------------------------------------------------------------------------------------------- //

// Populate div that announces when form confirmation message renders (forms must be AJAX)
// https://hub.accessible360.com/projects/9436/issues/54/
jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
	const confirmation = document.querySelector('#gform_confirmation_wrapper_' + formId);
	const liveRegion = document.querySelector('#gf-live-region-' + formId);

	if (liveRegion && confirmation) {
		liveRegion.textContent = confirmation.textContent.trim();
	}
});